var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-overlay',{attrs:{"id":"v-page-loader"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }